import { combineReducers } from 'redux';

import locations from './locations/reducer';
import places from './places/reducer';
import campgrounds from './campgrounds/reducer';
import visitorCenters from './visitorCenters/reducer';
import app from './app/reducer';
import users from './users/reducer';
import questions from './questions/reducer';
import reviews from './reviews/reducer';
import photos from './photos/reducer';
import alerts from './alerts/reducer';

const rootReducer = combineReducers({
  photos,
  locations,
  places,
  campgrounds,
  visitorCenters,
  app,
  users,
  questions,
  reviews,
  alerts,
});

export default rootReducer;
